module.exports = __webpack_public_path__ + "media/2.bef3a805.mp3";